// extracted by mini-css-extract-plugin
export default {"container":"YKUay0","header":"tpn2Qg","fixed":"lvoqQ8"};